import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StatusCase } from '../_models/mcst-model';
import { PrivateService } from './private.service';

@Injectable({
  providedIn: 'root',
})

export class UserRoleService {
  private sharedObjectSource = new BehaviorSubject<any>(null);
  sharedObject$ = this.sharedObjectSource.asObservable();

  constructor(private service: PrivateService) { }

  updateSharedObject(newObject: any) {
    this.sharedObjectSource.next(newObject);
  }

  hasRole(allowedRoles: any): Observable<boolean> { 
    return this.sharedObject$.pipe(
        filter(obj => obj !== null && obj !== undefined && !this.isEmptyObject(obj)), // Wait for actual data
        map((obj: any) => { 
          if(Array.isArray(allowedRoles)){
            return allowedRoles.some(role => obj?.includes(role));
          } else {
            return obj?.includes(allowedRoles);
          }
        })
      );
  }

  isEmptyObject(obj: any): boolean {
    return typeof obj === 'object' && obj !== null && Object.keys(obj).length === 0;
  }

  getEditTemplate(): Observable<boolean> {
    return this.hasRole('EDIT_TEMPLATE');
  }

  getPreCaseAccess(): Observable<boolean> {
    return this.hasRole('PRE_CASES'); 
  }

  getReportingAccess(): Observable<boolean> {
    return this.hasRole('REPORTING'); 
  }

  getEditCloseCaseAccess(): Observable<boolean> {
    return this.hasRole('EDIT_CLOSED_CASES'); 
  }

  getEditActiveCaseAccess(): Observable<boolean> {
    return this.hasRole('EDIT_ACTIVE_CASES'); 
  }

  getAuditAccess(): Observable<boolean> {
    return this.hasRole('AUDIT'); 
  }

  getStaffAccess(): Observable<boolean> {
    return this.hasRole('STAFF_ADMIN'); 
  }

  getRequestMeetingAccess(): Observable<boolean> {
    return this.hasRole('REQUEST_MEETINGS'); 
  }

  getAdvancedReportAccess(): Observable<boolean> {
    return this.hasRole('VIEW_ADVANCED_REPORTS'); 
  }

  canEditCase(status: string): Observable<boolean> {
    const isActivePending = status === StatusCase.ACTIVE || status === StatusCase.PENDING_APPROVAL;
    const isClosedRejected = status === StatusCase.CLOSED || status === StatusCase.REJECTED;

    return combineLatest([
      this.getEditActiveCaseAccess(),
      this.getEditCloseCaseAccess()
    ]).pipe(
      map(([canEditActive, canEditClosed]) => {
        if (isActivePending) {
          return canEditActive;
        } else if (isClosedRejected) {
          return canEditClosed;
        }
        return false;
      })
    );
  }


}


// [
//     "PRE_CASES",
//     "REPORTING",
//     "EDIT_CLOSED_CASES",
//     "EDIT_ACTIVE_CASES",
//     "AUDIT",
//     "REQUEST_MEETINGS"
// ]